var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons8Chart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-chart",
    d: "M13,1a.477.477,0,0,0-.467.321l-.651,1.885A6.149,6.149,0,0,0,9.2,2.59a6.2,6.2,0,1,0,6.2,6.2,6.149,6.149,0,0,0-.615-2.674l1.884-.651a.477.477,0,0,0,.3-.607,6.208,6.208,0,0,0-3.837-3.837A.477.477,0,0,0,13,1Zm.262,1.136a5.212,5.212,0,0,1,2.605,2.606L11.885,6.115ZM8.727,3.569V8.318H3.979A5.238,5.238,0,0,1,8.727,3.569Zm.955,0a5.194,5.194,0,0,1,1.884.543l-.9,2.617a.477.477,0,0,0,.607.607l2.617-.9a5.231,5.231,0,0,1-.646,5.722L9.682,8.6Zm-5.7,5.7H9.007l3.558,3.558A5.25,5.25,0,0,1,3.979,9.272Z",
    transform: "translate(-3 -0.999)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Chart);
export default __webpack_public_path__ + "static/media/icons8-chart.bcec251b4fbb7bbc2cd3e272aa02f93b.svg";
export { ForwardRef as ReactComponent };